import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetQuestionsOfSurveyRPC } from "./getQuestionsOfSurveyRPC";

export class GetQuestionsOfSurveyRPCClientImpl extends GetQuestionsOfSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetQuestionsOfSurveyRPC.Request): Promise<LeoRPCResult<GetQuestionsOfSurveyRPC.Response, GetQuestionsOfSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetQuestionsOfSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetQuestionsOfSurveyRPC.ResponseDTO,
      GetQuestionsOfSurveyRPC.Errors.ErrorsDTO,
      GetQuestionsOfSurveyRPC.Response,
      GetQuestionsOfSurveyRPC.Errors.Errors
    >(
      response,
      "survey/GetQuestionsOfSurvey",
      GetQuestionsOfSurveyRPC.Response.fromDTO,
      GetQuestionsOfSurveyRPC.Errors.fromDTO
    );
  }
}
